import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { costs } from '../data/problems';
export function ProblemSection() {
  return <section className="border-t border-energy/15 py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-145" data-mp="30hzhn1ayjuld">
      <div className="mx-auto max-w-4xl px-4" data-id="element-146" data-mp="2vppn17ywe6cr">
        <div className="text-center" data-id="element-147" data-mp="39hvywhv0pr6e">
          <SectionHeading id="problem-title" data-id="element-148" data-mp="39guq6k1h5gru">Ti suona <span className="text-energy" data-id="element-149" data-mp="39jqmy51l5zep">familiare?</span></SectionHeading>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-haze" data-id="element-150" data-mp="35fr6fmgb30lc">
            Le energie rinnovabili sono nel tuo programma e gli studenti ne sentono parlare ogni giorno, ma trasformarle in
            lezioni chiare richiede tempo. Fotovoltaico, potenza del vento, accumulo e rete elettrica sono concetti che gli
            studenti faticano a visualizzare, e tu devi spiegarli senza materiali adeguati.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 rounded-2xl border border-energy/25 bg-navy-card p-6 shadow-lg sm:p-8" data-id="element-151" data-mp="jddbm61f48uh">
          <p className="mb-5 inline-flex items-center gap-2 text-xl font-extrabold uppercase text-cream" data-id="element-152" data-mp="x5behz4jd8i7">
            <AlertTriangleIcon className="h-5 w-5 text-gold" aria-hidden="true" data-id="element-153" data-mp="123360s19qslv" />
            Il vero problema:
          </p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-154" data-mp="174iteqqx5b7f">
            {costs.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-haze" data-id="element-155" data-mp="1c2ak5hftura1">
                <span className="mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full bg-gradient-to-br from-energy to-aqua" aria-hidden="true" data-id="element-156" data-mp="1g22yybvtdtnu" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <div className="mt-10 text-center" data-id="element-157" data-mp="3hv95u2xg9xlk">
          <p className="mx-auto max-w-2xl text-lg font-bold text-cream" data-id="element-158" data-mp="p00mtvr09x1r">
            Non ti servono altre informazioni sparse.
          </p>
          <p className="mt-3 text-2xl font-extrabold uppercase tracking-tight text-gold sm:text-3xl" data-id="element-159" data-mp="k2h86uqebi9a">Ti serve un sistema organizzato e pronto per la classe.</p>
        </div>
      </div>
    </section>;
}